import angular from 'angular';
import importBulkAttributesModalComponent from './import.bulk.attributes.modal.component';
export default angular.module('inv.customer.orderHistory.orderDetails.importBulkAttributesModal', []).component('importBulkAttributesModal', importBulkAttributesModalComponent).name;